import checkIsValidEmail from 'utils/checkIsValidEmail';

import { PartnerBulkUploadPayload } from './formatPartnerForBulkUpload';

export type PartnerBulkUploadRowValidation = {
  isValid: boolean;
  errors: string[];
};

type ValidateRowOptions = {
  t: (key: string) => string;
};

export const validatePartnerBulkUploadRow = (
  partner: PartnerBulkUploadPayload,
  { t }: ValidateRowOptions
): PartnerBulkUploadRowValidation => {
  const errors: string[] = [];

  if (!partner.name?.trim()) {
    errors.push(t('PartnerBulkUploadMissingName'));
  }

  if (!partner.cif?.trim()) {
    errors.push(t('PartnerBulkUploadMissingCif'));
  }

  if (
    partner.email &&
    !partner.isGeneratedEmail &&
    !checkIsValidEmail(partner.email)
  ) {
    errors.push(t('PartnerBulkUploadInvalidEmail'));
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
